import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import MemoIn from "../../../containers/modules/accounting/memo-in";

export default function MemoInRoute(props) {
  const { authUser } = props;
  return (
    <Route
      path="memo-in"
      index
      element={
        <AccessControl
          name={"Memo In Create"}
          auth={authUser}
          component={() => <MemoIn />}
        />
      }
    />
  );
}
